// 获取N天前日期
import de from "element-ui/src/locale/lang/de";

export function GetDateStr(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate() - AddDayCount);
    return getStr(dd)
}

// 获取N月前日期
export function GetMonthStr(AddMonthCount) {
    var dd = new Date();
    dd.setMonth(dd.getMonth() - AddMonthCount);
    return getStr(dd)
}

// 获取N年前日期
export function GetYearStr(AddYearCount) {
    var dd = new Date();
    dd.setYear(dd.getFullYear() - AddYearCount);
    return getStr(dd)
}

export function getStr(dd) {
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1;//获取当前月份的日期
    var d = dd.getDate();
    //判断 月
    if (m < 10) {
        m = "0" + m;
    } else {
        m = m;
    }
    //判断 日n
    if (d < 10) {//如果天数<10
        d = "0" + d;
    } else {
        d = d;
    }
    return y + "-" + m + "-" + d;
}

export function GetTime(dd) {
    var date = new Date(dd);
    var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return h + ":" + minute;
}

// 小数转分钟数
export function GetMinute(y) {
    let c = y.toString().split('.');
    c[0] = '0';
    c = Math.floor(Number(c.join('.')) * 60);
    return c;
}

// 秒转时分秒
export function SwitchTime(time) {
    if (time) {
        let h = parseInt(time / 60 / 60 % 24)
        h = h < 10 ? '0' + h : h
        let m = parseInt(time / 60 % 60)
        m = m < 10 ? '0' + m : m
        let s = parseInt(time % 60)
        s = s < 10 ? '0' + s : s
        return h + ':' + m + ':' + s
    } else {
        return '- -'
    }
}

// 秒转时分秒，不去24
export function SwitchTime24(time) {
    if (time) {
        let h = parseInt(time / 60 / 60)
        h = h < 10 ? '0' + h : h
        let m = parseInt(time / 60 % 60)
        m = m < 10 ? '0' + m : m
        let s = parseInt(time % 60)
        s = s < 10 ? '0' + s : s
        return h + ':' + m + ':' + s
    } else {
        return '- -'
    }
}

// 秒转时分秒
export function SwitchTimeToM(time) {
    let h = parseInt(time / 60 / 60 % 24);
    let m = h * 60 + parseInt(time / 60 % 60)
    let s = parseInt(time % 60)
    return m + "'" + s + "''"
}

// 获取某月第一天
export function getMonthStartDay(n) {
    return GetMonth(n) + '-01';
}

// 获取某月最后一天
export function getMonthEndDay(n) {
    let date = GetMonth(n).split('-');
    var d = new Date(date[0], parseInt(date[1]), 0).getDate(); //获取当月最后一日
    d = d < 10 ? '0' + d : d; //日数补 0

    return GetMonth(n) + '-' + d;
}

// 获取某月
export function GetMonth(n) {
    //当前时间
    var currentDate = new Date();
    var month = currentDate.getMonth() + n;
    if (month < 0) {
        var n = parseInt(-month / 12);
        month += n * 12;
        currentDate.setFullYear(currentDate.getFullYear() - n);
    }
    currentDate = new Date(currentDate.setMonth(month));
    //获得当前月份0-11
    var m = currentDate.getMonth() + 1;
    //获得当前年份4位年
    var y = currentDate.getFullYear();
    m = m < 10 ? '0' + m : m; //月份补 0
    return y + '-' + m;
}

// 获取某年
export function GetYear(n) {
    var y = new Date().getFullYear() + n; //获取年份
    return y;
}

export function getDistanceDays(date1, date2) {
    // date1例如:'2022-03-05',date2例如:'2022-03-06'
    const date1_timeStamp = toTimeStamp(date1)
    const date2_timeStamp = toTimeStamp(date2)
    let max = '', min = ''
    if (date1_timeStamp > date2_timeStamp) {
        max = date1_timeStamp
        min = date2_timeStamp
    } else {
        max = date2_timeStamp
        min = date1_timeStamp
    }
    // 例如返回:'1'
    return Math.ceil((max - min) / (24 * 60 * 60 * 1000));
}

// 指定时间转换为时间戳
function toTimeStamp(dateString) {
    // dateString例如:'2022-03-05'
    // 例如返回:1646611200000
    return new Date(dateString) - 0
}

// 获取今天
export function getToday() {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    month = (month > 9) ? month : ("0" + month);
    day = (day < 10) ? ("0" + day) : day;
    return year + "-" + month + "-" + day;
}


export function getNWeekFirstDay(offset) {
    const now = new Date();
    const dayOfWeek = now.getDay();
    const daysToSunday = -dayOfWeek;

    const sunday = new Date(now.getTime() + (offset * 7 * 24 * 60 * 60 * 1000) + (daysToSunday * 24 * 60 * 60 * 1000));
    return sunday.toISOString().split('T')[0];
}

export function getNWeekLastDay(offset) {
    const sunday = getNWeekFirstDay(offset);
    const saturday = new Date(new Date(sunday).getTime() + 6 * 24 * 60 * 60 * 1000);
    return saturday.toISOString().split('T')[0];
}
export function getAge(strBirthday) {
    var returnAge;

    var strBirthdayArr = strBirthday.split("-");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2];

    let d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
        returnAge = 0;//同年 则为0岁
    } else {
        var ageDiff = nowYear - birthYear; //年之差
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;//日之差
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth;//月之差
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = '- -';//出生日期不能大于今天
        }
    }
    return returnAge;
}

export function getDateDiff(n) {
    let dateTimeStamp = getDateTimeStamp(n)
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var halfamonth = day * 15;
    var month = day * 30;

    var now = new Date().getTime();
    var diffValue = now - dateTimeStamp;
    if (diffValue < 0) {
        //若日期不符则弹出窗口告之
        //alert("结束日期不能小于开始日期！");
    }
    var monthC = diffValue / month;
    var weekC = diffValue / (7 * day);
    var dayC = diffValue / day;
    var hourC = diffValue / hour;
    var minC = diffValue / minute;
    let result = n
    if (monthC >= 1) {
        result = parseInt(monthC) + "月前";
    } else if (weekC >= 1) {
        result = parseInt(weekC) + "周前";
    } else if (dayC >= 1) {
        result = parseInt(dayC) + "天前";
    } else if (hourC >= 1) {
        result = parseInt(hourC) + "小时前";
    } else if (minC >= 1) {
        result = parseInt(minC) + "分钟前";
    } else
        result = "刚刚";
    return result;
}


function getDateTimeStamp(dateStr){
    return Date.parse(dateStr.replace(/-/gi,"/"));
}

// 获取指定日期天数
export function getMonthDays(date) {
    var date = new Date(date);
    var year = date.getFullYear();
    var month = date.getMonth()+1;
    var days = new Date(year, month, 0);
    return days.getDate();
}

// 修改日期格式为M/d
export function changeDate(date) {
    date = new Date(date.replace(/-/g,'/'));
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return month + "/" + day;
}

export function getDateDay(date) {
    date = new Date(date.replace(/-/g,'/'));
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return day;
}


export function getDateWeek(date) {
    date = new Date(date.replace(/-/g,'/'));
    var week = date.getDay();
    return week;
}

// 修改日期格式为M/d
export function changeDateY(date) {
    date = new Date(date.replace(/-/g,'/'));
    let year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return year + "/" + month + "/" + day;
}

// 修改日期格式为M/d
export function changeDateM(date) {
    date = date + '-01';
    date = new Date(date.replace(/-/g,'/'));
    let year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return year + "/" + month;
}

// 修改日期格式为Y年M月
export function changeMonthDate(date) {
    date = new Date(date);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) {
        month = '0' + month;
    }
    return year + "/" + month;
}

// 获取两个日期之间的天数
export function getDaysBetweenDates(date1, date2) {
    // 将日期字符串转换为Date对象
    var d1 = new Date(date1);
    var d2 = new Date(date2);

    // 计算两个日期的时间差（毫秒）
    var timeDiff = Math.abs(d2.getTime() - d1.getTime());

    // 计算天数
    var days = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return days;
}

//  秒数转化为分秒
export function formatSeconds(value) {
    value = Number(value);
    if (value == 0) {
        return '--';
    }
    let h = parseInt(value / 60 / 60 % 24);
    let m = h * 60 + parseInt(value / 60 % 60)
    let s = parseInt(value % 60)
    if (s < 10) {
        s = '0' + s;
    }
    return m + "'" + s + "''"
}


//  秒数转化为时分秒
export function formatSeconds2(value) {
    value = Number(value);
    // if (value == 0) {
    //     return '--';
    // }
    let secondTime = parseInt(value);
    let minuteTime = 0;
    let hourTime = 0;
    if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
            hourTime = parseInt(minuteTime / 60);
            minuteTime = parseInt(minuteTime % 60);
        }
    }
    // 补0
    hourTime = hourTime < 10 ? "0" + hourTime : hourTime;
    minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
    secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
    let res = hourTime + ":" + minuteTime + ":" + secondTime;
    return res;
}

//  秒数转化为时分秒
export function formatSeconds3(value) {
    // if (value == 0) {
    //     return '--';
    // }
    let secondTime = parseInt(value);
    let minuteTime = 0;
    let hourTime = 0;
    if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime >= 60) {
            hourTime = parseInt(minuteTime / 60);
            minuteTime = parseInt(minuteTime % 60);
        }
    }
    // 补0
    hourTime = hourTime < 10 ? "0" + hourTime : hourTime;
    minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
    secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
    let res;
    if (hourTime == 0) {
        res = minuteTime + ":" + secondTime;
    } else {
        res = hourTime + ":" + minuteTime + ":" + secondTime;
    }
    return res;
}

// 获取今天星期几 0-6 表示周一到周日
export function getWeekNum() {
    let now = new Date();
    let dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)
    // 调整为0 (Monday) to 6 (Sunday)
    let adjustedDayOfWeek = (dayOfWeek + 6) % 7;
    return adjustedDayOfWeek;
}


// 获取一个月后的今天
export function getTodayNextMonth() {
    var date = new Date();
    date.setMonth(date.getMonth() + 1);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    month = (month > 9) ? month : ("0" + month);
    day = (day < 10) ? ("0" + day) : day;
    return year + "-" + month + "-" + day;
}

export function getNowTimeToSecond() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 秒转时分秒，不去24
export function SwitchTime24hms(time) {
    if (time) {
        let h = parseInt(time / 60 / 60)
        let m = parseInt(time / 60 % 60)
        let s = parseInt(time % 60)
        let result = '';
        if (h > 0) {
            result = h + 'h'
        }
        if (m > 0) {
            result += m + 'm'
        }
        if (s > 0) {
            result += s + 's'
        }
        return result
    } else {
        return '0s'
    }
}

// 计算时间差的函数
export function calculateDuration(start, end) {
    const startTs = new Date(start).getTime(); // 转换为毫秒
    const endTs = new Date(end).getTime(); // 转换为毫秒
    const diffInMinutes = Math.round((endTs - startTs) / 60000); // 毫秒转分钟
    return diffInMinutes;
}

export function convertTo12Hour(timeStr) {
    const [hours, minutes] = timeStr.trim().split(':').map(Number);
    const period = hours >= 12 ? 'pm' : 'am';
    const hour12 = hours % 12 || 12;
    return `${hour12}${period}`;
}


// WEBPACK FOOTER //
// ./src/utils/dateUtils.js